export default {
	"plan": {
		"pickUpPeriod": "ระยะเวลารับสินค้า",
		"deliveryPeriod": "ระยะเวลาจัดส่ง",
		"notPickup": "ห้ามรับสินค้า",
		"noDelivery": "ไม่ได้จัดส่ง",
		"saveTransportOrderSort": "บันทึกใบตราส่งสินค้าแล้ว",
		"transfer": "ระหว่างการขนส่ง",
		"revokeTransfer": "ยกเลิกการโอน",
		"notNeedPickUp": "ใบตราส่งสินค้าไม่กำหนดให้ไปรับสินค้า",
		"canNotPickUp": "ใบตราส่งสินค้ากำหนดให้สามารถรับสินค้าได้",
		"notNeedDelivery": "รายการนี้ไม่ต้องจัดส่ง",
		"canNotDelivery": "จัดส่งรอบเดียว"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/plan/plan.js